<template>
    <div>
        <ly-form-item label="城市" lw="2.5">
            <Input size="small" readonly @on-focus="$refs.city.open()" v-model="city"></Input>
        </ly-form-item>
        <ly-form-item label="币别" lw="2.5">
            <currency v-model="currency"></currency>
        </ly-form-item>
        <ly-form-item label="基础价" lw="3.5">
            <InputNumber size="small" style="width:60px;" v-model="num"></InputNumber>
        </ly-form-item>

        <ly-form-item label="地址单价" lw="4.5">
            <InputNumber size="small" style="width:60px;" v-model="unitPirce"></InputNumber>
        </ly-form-item>
        <select-city v-show="false" @aaa="getCity" :hideInput="true" ref="city">
        </select-city>
    </div>
</template>
<script>
import currency from "../baojia/currency.vue";
export default {
    props: ["bbb",],
    components: { currency },
    model: {
        prop: "bbb",
        event: "aaa",
    },
    data() {
        return {
            num: 0,
            unitPirce: 0,
            currency: '',
            city: ''
        }
    },
    methods: {
        tt() {
            //console.log(this.bbb);
            eval('this.' + this.bbb);

        },
        paisong(a, b, c, d) {
            this.num = a;
            this.unitPirce = b;
            this.currency = c;
            this.city = d;
        },
        emit() {
            this.$emit('aaa', "paisong(" +
                this.num + "," + this.unitPirce + ",'" +
                this.currency + "','" + this.city + "')")
        },
        getCity(v) {
            this.city = v;
        },
    },
    mounted() {
        this.tt();
    },
    watch: {
        num(v) {
            this.emit();
        },
        currency() {
            this.emit();
        },
        unitPirce(v) {
            this.emit();
        },
        city() {
            this.emit();
        },
        bbb() {
            this.tt();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/gongshi/paisong.vue